import WSA from '../WSA';
import ExternalRedirect from './ExternalRedirect';

const Signin = () => {
  const signinUrl = WSA.urls.getSignin();
  return <ExternalRedirect externalUrl={signinUrl} shouldUseReplace />;
};
export default Signin;
